import { theme } from '../lib/styles/theme';

export const getSvgSelected = (tableId, colId, rowId) => {
    if (!tableId || !colId) return null;

    if (!rowId) {
        return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
                    <defs>
                        <path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" id="checked-table-${tableId}-col-${colId}"/>
                    </defs><use fill="${theme.colors.actionMajor[500]}" xlink:href="#checked-table-${tableId}-col-${colId}" fill-rule="evenodd"/>
                </svg>`;
    } else {
        return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
                    <defs>
                        <path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" id="checked-table-${tableId}-col-${colId}-row-${rowId}"/>
                    </defs><use fill="${theme.colors.actionMajor[500]}" xlink:href="#checked-table-${tableId}-col-${colId}-row-${rowId}" fill-rule="evenodd"/>
                </svg>`;
    }
};

export const getSvgNonSelected = (tableId, colId, rowId) => {
    if (!tableId || !colId) return null;
    if (!rowId) {
        return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
                    <defs>
                        <path d="M19 5v14H5V5h14zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" id="none-checked-table-${tableId}-col-${colId}"/>
                    </defs>
                    <use fill="${theme.colors.actionMinor[400]}" xlink:href="#none-checked-table-${tableId}-col-${colId}" fill-rule="evenodd"/>
                </svg>`;
    } else {
        return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
                    <defs>
                        <path d="M19 5v14H5V5h14zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" id="none-checked-table-${tableId}-col-${colId}-row-${rowId}"/>
                    </defs>
                    <use fill="${theme.colors.actionMinor[400]}" xlink:href="#none-checked-table-${tableId}-col-${colId}-row-${rowId}" fill-rule="evenodd"/>
                </svg>`;
    }
};

export const getSvgSomeSelected = (tableId, colId) => {
    if (!tableId || !colId) return null;

    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" id="some-checked-table-${tableId}-col-${colId}"/>
                </defs>
                <use fill="${theme.colors.actionMajor[500]}" xlink:href="#some-checked-table-${tableId}-col-${colId}" fill-rule="evenodd"/>
            </svg>`;
};
